const EMPLOYMENT_STATUS = [
  { value: 'active', label: 'Aktiv' },
  { value: 'inactive', label: 'Inaktiv' },
  { value: 'sickLeave', label: 'Sygemeldt' },
  { value: 'leave', label: 'Orlov' },
  { value: 'other', label: 'Andet' },
];

export default EMPLOYMENT_STATUS;
